export default __webpack_public_path__ + "static/media/creditModerne-logo.d829ad30.svg";